//old
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import NoInternetConnection from "./offline";
import Login from "./Component/Account/Login";
import Register from "./Component/Account/Register";
import Dashboard from "./Component/Dashboard";
import CarInquiry from "./Component/carInquiry";
import Payment from "./Component/Payment";
import MyCar from "./Component/MyCar";
import CarDetail from "./Component/CarDetail";
import Catlogue from "./Component/Catalogue/Innercatalogue/MyCatlogue";
import Catlogue_Detail from "./Component/Catalogue/Innercatalogue/Catlogue_Detail";
import Catlogueshare from "./Component/Catalogue/Outercatalogue/Catlogueshare";
import Editinquiry from "./Component/Editinquiry";
import Soldunsold from "./Component/Soldunsold";
import Service from "./Component/Services/Service";
import CatDetails from "./Component/Catalogue/Outercatalogue/CatDetails";
import CreateStatus from "./Component/CreateStatus";
import Statuspage from "./Component/Statuspage";
import GenerateQr from "./Component/GenerateQr";
import SearchDoc from "./Component/SearchDoc";
import Leadform from "./Component/Lead-Section/Leadform";
import Leaddata from "./Component/Lead-Section/Leaddata";
// import { ApiProvider } from "./Component/ApiContext";
import Profile from "./Component/Account/Profile";
import Carstationary from "./Component/Services/Carstationary";
import Updatedcarprice from "./Component/Services/Updatedcarprice";
import CheckRC from "./Component/Services/CheckRc";
import Addlead from "./Component/Lead-Section/Addlead";
import Supportpage from "./Component/Supportpage";
import Changepassword from "./Component/Account/Changepassword";
import ForgetPassword from "./Component/Account/ForgetPassword";
import NewPassword from "./Component/Account/NewPassword";
import CarValuation from "./Component/CarValuation-calc";
import Help from "./Component/Help";
import IndividualCarPhotoShare from "./Component/Individual_CarPhotoShare";
import { LoanEmi } from "./Component/Services/Clac-Loanemi";
import SearchmoreCars from "./Component/SearchmoreCars";
import { SearchProvider } from "./Component/Searchcontext";
import OtherCarDetails from "./Component/OtherCarDetials";
import Challan from "./Component/Services/Challan";
import AllFrame from "./Component/Greeting_Module/AllFrame";
import Specifiedcarcatlogue from "./Component/Catalogue/Innercatalogue/Specifiedcarcatlogue";
import Specficatlogueshare from "./Component/Catalogue/Outercatalogue/Specficcatlogueshare";
import Undermaintenance from "./Component/Undermaintenance";
import AllImages from "./Component/Greeting_Module/AllImages";
import MessageTemplate from "./Component/Services/Message_Template";
import ObjectDetection from "./Component/tryimagedetection";
import Challaninuse from "./Component/Services/Challaninuse";
import Report from "./Component/Reports/Report";
import Stockrecord from "./Component/Stockrecord";
import SearchBuyerSeller from "./Component/SerchBuyerSeller";
import AllUpdatedNotification from "./Component/AllUpdatedNotification";
import SalesExecutive from "./Component/Lead-Section/SalesExecutive";
import Trashbin from "./Component/Trashbin";
import MakeCustomizepost from "./Component/MakeCustomizepost";

import { Test } from "./Component/Test";
import TwaShortcutMyCatalogue from "./Component/Catalogue/TwaShortcutMyCatalogue";
import SoldUnsoldThisMonth from "./Component/homepages/SoldUnsoldThisMonth";
import CustomerCarList from "./Component/homepages/CustomerCarList";
import CustomerCarDetail from "./Component/homepages/CustomerCarDetail";
import { CustomerCarProvider } from "./Component/Contexts/CustomerCarListContext";
import { MyCarContextProvider } from "./Component/Contexts/MyCarContext";
import NotificationHandler from "./notification/NotificationHandler";
import { isIOS } from "./Component/Utils/general-function";
import GearwiseCatalog from "./Component/Catalogue/Innercatalogue/GearwiseCatalog";
import GearwiseCatalogProvider from "./Component/Contexts/GearwiseCatalogContext";
import GearwiseCatalogShare from "./Component/Catalogue/Outercatalogue/GearwiseCatalogShare";
import FuelwiseCatalog from "./Component/Catalogue/Innercatalogue/FuelwiseCatalog";
import FuelwiseContextProvider from "./Component/Contexts/FuelwiseCatalogContext";
import FuelwiseCatalogShare from "./Component/Catalogue/Outercatalogue/FuelwiseCatalogShare";
import OwnerwiseCatalog from "./Component/Catalogue/Innercatalogue/OwnerwiseCatalog";
import ShareUploadFromOtherapps from "./Component/Uploadimage/ShareUploadFromOtherapps";
import Test2 from "./Test2";
import { MyWallet } from "./Component/razorpay/MyWallet";
import { PaymentSucc } from "./Component/razorpay/PaymentSucc";
import LeadTemporyListAlert from "./Component/Lead-Section/LeadTemporyListAlert";
import CustomerCarWishlists from "./Component/customer_car/CustomerCarWishlists";
import CarthiInsurance from "./Component/Services/CarthiInsurance";
import RcSearchLog from "./Component/Services/RcSearchLog";
import CarthiFinance from "./Component/Services/CarthiFinance";

function App() {
  return (
    // <ApiProvider>

    <div>
      <NoInternetConnection>
        {!isIOS() && <NotificationHandler />}
        <Router basename={process.env.PUBLIC_URL}>
          <Routes>
            <Route exact path="/Login" element={<Login />} />
            <Route exact path="/Register" element={<Register />} />
            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="/CarInquiry" element={<CarInquiry />} />
            <Route exact path="/Payment" element={<Payment />} />
            <Route
              exact
              path="/MyCar"
              element={
                <MyCarContextProvider>
                  <MyCar />
                </MyCarContextProvider>
              }
            />
            <Route
              exact
              path="/CarDetail"
              element={
                <MyCarContextProvider>
                  <CarDetail />
                </MyCarContextProvider>
              }
            />
            <Route exact path="/Catlogue/:id" element={<Catlogue />} />
            <Route
              exact
              path="/Catlogueshare/:id/:name"
              element={<Catlogueshare />}
            />
            <Route
              exact
              path="/Catlogue_Detail/:carno"
              element={
                <GearwiseCatalogProvider>
                  <SearchProvider>
                    <Catlogue_Detail />
                  </SearchProvider>
                </GearwiseCatalogProvider>
              }
            />
            <Route
              exact
              path="/Editinquiry"
              element={
                <GearwiseCatalogProvider>
                  <MyCarContextProvider>
                    <Editinquiry />
                  </MyCarContextProvider>
                </GearwiseCatalogProvider>
              }
            />
            <Route exact path="/Soldunsold" element={<Soldunsold />} />
            <Route exact path="/Service" element={<Service />} />
            <Route
              exact
              path="/CatDetails/:carno/:dealerid/:brandoption"
              element={<CatDetails />}
            />
            <Route exact path="/CreateStatus" element={<CreateStatus />} />
            <Route
              exact
              path="/Statuspage"
              element={
                <GearwiseCatalogProvider>
                  <Statuspage />
                </GearwiseCatalogProvider>
              }
            />
            <Route exact path="/GenerateQr" element={<GenerateQr />} />
            <Route exact path="/SearchDoc" element={<SearchDoc />} />
            <Route
              exact
              path="/Leadform/:no/:Rand/:dealerid"
              element={<Leadform />}
            />
            <Route exact path="/Leaddata" element={<Leaddata />} />
            <Route exact path="/Profile" element={<Profile />} />
            <Route exact path="/Carstationary" element={<Carstationary />} />
            <Route
              exact
              path="/Updatedcarprice"
              element={<Updatedcarprice />}
            />
            <Route exact path="/CheckRC" element={<CheckRC />} />
            <Route exact path="/Addlead" element={<Addlead />} />
            <Route exact path="/Supportpage" element={<Supportpage />} />
            <Route exact path="/Changepassword" element={<Changepassword />} />
            <Route exact path="/ForgetPassword" element={<ForgetPassword />} />
            <Route exact path="/NewPassword" element={<NewPassword />} />
            <Route exact path="/CarValuation" element={<CarValuation />} />
            <Route exact path="/Challan" element={<Challan />} />
            <Route
              exact
              path="/Undermaintenance"
              element={<Undermaintenance />}
            />
            <Route exact path="/Help" element={<Help />} />
            <Route exact path="/AllImages" element={<AllImages />} />
            <Route
              exact
              path="/IndividualCarPhotoShare/:caRand/:dealerid"
              element={<IndividualCarPhotoShare />}
            />
            <Route exact path="/LoanEmi" element={<LoanEmi />} />

            <Route
              exact
              path="/SearchmoreCars"
              element={
                <SearchProvider>
                  <SearchmoreCars />
                </SearchProvider>
              }
            />

            <Route
              exact
              path="/OtherCarDetails/:carno/"
              element={
                <SearchProvider>
                  <OtherCarDetails />
                </SearchProvider>
              }
            />

            <Route exact path="/AllFrame" element={<AllFrame />} />
            <Route
              exact
              path="/Specifiedcarcatlogue/"
              element={
                <SearchProvider>
                  <Specifiedcarcatlogue />
                </SearchProvider>
              }
            />
            <Route
              exact
              path="/Specficatlogueshare/:id/:modelid/:Brand"
              element={<Specficatlogueshare />}
            />
            <Route
              exact
              path="/MessageTemplate"
              element={<MessageTemplate />}
            />
            <Route
              exact
              path="/ObjectDetection"
              element={<ObjectDetection />}
            />
            <Route exact path="/Challaninuse" element={<Challaninuse />} />
            <Route exact path="/Report" element={<Report />} />
            <Route exact path="/Stockrecord/:name" element={<Stockrecord />} />
            <Route
              exact
              path="/SearchBuyerSeller"
              element={<SearchBuyerSeller />}
            />
            <Route
              exact
              path="/AllUpdatedNotification"
              element={<AllUpdatedNotification />}
            />
            <Route exact path="/SalesExecutive" element={<SalesExecutive />} />
            <Route exact path="/Trashbin" element={<Trashbin />} />
            <Route exact path="/Test" element={<Test />} />
            <Route
              exact
              path="/MakeCustomizepost"
              element={<MakeCustomizepost />}
            />
            <Route
              exact
              path="/twashortcutmycatalogue"
              element={<TwaShortcutMyCatalogue />}
            />
            <Route
              exact
              path="/soldunsoldthismonth"
              element={<SoldUnsoldThisMonth />}
            />
            <Route
              exact
              path="/customercarlist"
              element={
                <CustomerCarProvider>
                  <CustomerCarList />
                </CustomerCarProvider>
              }
            />
            <Route
              exact
              path="/customercardetail/:carRand"
              element={
                <CustomerCarProvider>
                  <CustomerCarDetail />
                </CustomerCarProvider>
              }
            />
            <Route
              path="/gearwisecatalog"
              element={
                <GearwiseCatalogProvider>
                  <GearwiseCatalog />
                </GearwiseCatalogProvider>
              }
            />
            <Route
              path="/fuelwisecatalog"
              element={
                <FuelwiseContextProvider>
                  <FuelwiseCatalog />
                </FuelwiseContextProvider>
              }
            />
            <Route
              path="/gearwisecatalogshare/:dealerid/:gearid/:brandshowing"
              element={<GearwiseCatalogShare />}
            />
            <Route path="/fuelwisecatalog" element={<FuelwiseCatalog />} />
            <Route
              path="/fuelwisecatalogshare/:dealerid/:fuelid/:brandshowing"
              element={<FuelwiseCatalogShare />}
            />
            <Route path="/ownerwisecatalog" element={<OwnerwiseCatalog />} />
            <Route
              path="/share-upload-from-otherapps"
              element={<ShareUploadFromOtherapps />}
            />
            <Route path="/mywallet" element={<MyWallet />} />
            <Route path="payment-success" element={<PaymentSucc />} />

            <Route path="test2" element={<Test2 />} />
            <Route
              path="/leadtemporylistalert"
              element={<LeadTemporyListAlert />}
            />
            <Route
              path="/customercarwishlists/:dealerrand"
              element={<CustomerCarWishlists />}
            />
            <Route path="/carthiinsurance" element={<CarthiInsurance />} />
            <Route path="/carthifinance" element={<CarthiFinance />} />
            <Route path="/rcsearchlog" element={<RcSearchLog />} />
          </Routes>
        </Router>
      </NoInternetConnection>
    </div>
    // {/* </ApiProvider> */}
  );
}

export default App;

// group context in appprovider
// import { HashRouter as Router, Routes, Route } from "react-router-dom";
// import NoInternetConnection from "./offline";
// import Login from "./Component/Account/Login";
// import Register from "./Component/Account/Register";
// import Dashboard from "./Component/Dashboard";
// import CarInquiry from "./Component/carInquiry";
// import Payment from "./Component/Payment";
// import MyCar from "./Component/MyCar";
// import CarDetail from "./Component/CarDetail";
// import Catlogue from "./Component/Catalogue/Innercatalogue/MyCatlogue";
// import Catlogue_Detail from "./Component/Catalogue/Innercatalogue/Catlogue_Detail";
// import Catlogueshare from "./Component/Catalogue/Outercatalogue/Catlogueshare";
// import Editinquiry from "./Component/Editinquiry";
// import Soldunsold from "./Component/Soldunsold";
// import Service from "./Component/Services/Service";
// import CatDetails from "./Component/Catalogue/Outercatalogue/CatDetails";
// import CreateStatus from "./Component/CreateStatus";
// import Statuspage from "./Component/Statuspage";
// import GenerateQr from "./Component/GenerateQr";
// import SearchDoc from "./Component/SearchDoc";
// import Leadform from "./Component/Lead-Section/Leadform";
// import Leaddata from "./Component/Lead-Section/Leaddata";
// // import { ApiProvider } from "./Component/ApiContext";
// import Profile from "./Component/Account/Profile";
// import Carstationary from "./Component/Services/Carstationary";
// import Updatedcarprice from "./Component/Services/Updatedcarprice";
// import CheckRC from "./Component/Services/CheckRc";
// import Addlead from "./Component/Lead-Section/Addlead";
// import Supportpage from "./Component/Supportpage";
// import Changepassword from "./Component/Account/Changepassword";
// import ForgetPassword from "./Component/Account/ForgetPassword";
// import NewPassword from "./Component/Account/NewPassword";
// import CarValuation from "./Component/CarValuation-calc";
// import Help from "./Component/Help";
// import IndividualCarPhotoShare from "./Component/Individual_CarPhotoShare";
// import { LoanEmi } from "./Component/Services/Clac-Loanemi";
// import SearchmoreCars from "./Component/SearchmoreCars";
// import { SearchProvider } from "./Component/Searchcontext";
// import OtherCarDetails from "./Component/OtherCarDetials";
// import Challan from "./Component/Services/Challan";
// import AllFrame from "./Component/Greeting_Module/AllFrame";
// import Specifiedcarcatlogue from "./Component/Catalogue/Innercatalogue/Specifiedcarcatlogue";
// import Specficatlogueshare from "./Component/Catalogue/Outercatalogue/Specficcatlogueshare";
// import Undermaintenance from "./Component/Undermaintenance";
// import AllImages from "./Component/Greeting_Module/AllImages";
// import MessageTemplate from "./Component/Services/Message_Template";
// import ObjectDetection from "./Component/tryimagedetection";
// import Challaninuse from "./Component/Services/Challaninuse";
// import Report from "./Component/Reports/Report";
// import Stockrecord from "./Component/Stockrecord";
// import SearchBuyerSeller from "./Component/SerchBuyerSeller";
// import AllUpdatedNotification from "./Component/AllUpdatedNotification";
// import SalesExecutive from "./Component/Lead-Section/SalesExecutive";
// import Trashbin from "./Component/Trashbin";
// import MakeCustomizepost from "./Component/MakeCustomizepost";

// import { Test } from "./Component/Test";
// import TwaShortcutMyCatalogue from "./Component/Catalogue/TwaShortcutMyCatalogue";
// import SoldUnsoldThisMonth from "./Component/homepages/SoldUnsoldThisMonth";
// import CustomerCarList from "./Component/homepages/CustomerCarList";
// import CustomerCarDetail from "./Component/homepages/CustomerCarDetail";
// import { CustomerCarProvider } from "./Component/Contexts/CustomerCarListContext";
// import { MyCarContextProvider } from "./Component/Contexts/MyCarContext";
// import NotificationHandler from "./notification/NotificationHandler";
// import { isIOS } from "./Component/Utils/general-function";
// import GearwiseCatalog from "./Component/Catalogue/Innercatalogue/GearwiseCatalog";
// import GearwiseCatalogProvider from "./Component/Contexts/GearwiseCatalogContext";
// import GearwiseCatalogShare from "./Component/Catalogue/Outercatalogue/GearwiseCatalogShare";
// import FuelwiseCatalog from "./Component/Catalogue/Innercatalogue/FuelwiseCatalog";
// import FuelwiseContextProvider from "./Component/Contexts/FuelwiseCatalogContext";
// import FuelwiseCatalogShare from "./Component/Catalogue/Outercatalogue/FuelwiseCatalogShare";
// import AppProviders from "./Component/Contexts/AppProviders";

// function App() {
//   return (
//     // <ApiProvider>

//     <div>
//       <NoInternetConnection>
//         {!isIOS() && <NotificationHandler />}
//         <Router basename={process.env.PUBLIC_URL}>
//           <Routes>
//             <Route element={<AppProviders />}>
//               <Route exact path="/Login" element={<Login />} />
//               <Route exact path="/Register" element={<Register />} />
//               <Route exact path="/" element={<Dashboard />} />
//               <Route exact path="/CarInquiry" element={<CarInquiry />} />
//               <Route exact path="/Payment" element={<Payment />} />
//               <Route
//                 exact
//                 path="/MyCar"
//                 element={
//                   <MyCarContextProvider>
//                     <MyCar />
//                   </MyCarContextProvider>
//                 }
//               />
//               <Route
//                 exact
//                 path="/CarDetail"
//                 element={
//                   <MyCarContextProvider>
//                     <CarDetail />
//                   </MyCarContextProvider>
//                 }
//               />
//               <Route exact path="/Catlogue/:id" element={<Catlogue />} />
//               <Route
//                 exact
//                 path="/Catlogueshare/:id/:name"
//                 element={<Catlogueshare />}
//               />
//               <Route
//                 exact
//                 path="/Catlogue_Detail/:carno"
//                 element={
//                   // <FuelwiseContextProvider>
//                   //   <GearwiseCatalogProvider>
//                   //     <SearchProvider>
//                   <Catlogue_Detail />
//                   //     </SearchProvider>
//                   //   </GearwiseCatalogProvider>
//                   // </FuelwiseContextProvider>
//                 }
//               />
//               <Route
//                 exact
//                 path="/Editinquiry"
//                 element={
//                   // <GearwiseCatalogProvider>
//                   //   <MyCarContextProvider>
//                   <Editinquiry />
//                   //   </MyCarContextProvider>
//                   // </GearwiseCatalogProvider>
//                 }
//               />
//               <Route exact path="/Soldunsold" element={<Soldunsold />} />
//               <Route exact path="/Service" element={<Service />} />
//               <Route
//                 exact
//                 path="/CatDetails/:carno/:dealerid/:brandoption"
//                 element={<CatDetails />}
//               />
//               <Route exact path="/CreateStatus" element={<CreateStatus />} />
//               <Route
//                 exact
//                 path="/Statuspage"
//                 element={
//                   // <GearwiseCatalogProvider>
//                   <Statuspage />
//                   // </GearwiseCatalogProvider>
//                 }
//               />
//               <Route exact path="/GenerateQr" element={<GenerateQr />} />
//               <Route exact path="/SearchDoc" element={<SearchDoc />} />
//               <Route
//                 exact
//                 path="/Leadform/:no/:Rand/:dealerid"
//                 element={<Leadform />}
//               />
//               <Route exact path="/Leaddata" element={<Leaddata />} />
//               <Route exact path="/Profile" element={<Profile />} />
//               <Route exact path="/Carstationary" element={<Carstationary />} />
//               <Route
//                 exact
//                 path="/Updatedcarprice"
//                 element={<Updatedcarprice />}
//               />
//               <Route exact path="/CheckRC" element={<CheckRC />} />
//               <Route exact path="/Addlead" element={<Addlead />} />
//               <Route exact path="/Supportpage" element={<Supportpage />} />
//               <Route
//                 exact
//                 path="/Changepassword"
//                 element={<Changepassword />}
//               />
//               <Route
//                 exact
//                 path="/ForgetPassword"
//                 element={<ForgetPassword />}
//               />
//               <Route exact path="/NewPassword" element={<NewPassword />} />
//               <Route exact path="/CarValuation" element={<CarValuation />} />
//               <Route exact path="/Challan" element={<Challan />} />
//               <Route
//                 exact
//                 path="/Undermaintenance"
//                 element={<Undermaintenance />}
//               />
//               <Route exact path="/Help" element={<Help />} />
//               <Route exact path="/AllImages" element={<AllImages />} />
//               <Route
//                 exact
//                 path="/IndividualCarPhotoShare/:caRand/:dealerid"
//                 element={<IndividualCarPhotoShare />}
//               />
//               <Route exact path="/LoanEmi" element={<LoanEmi />} />

//               <Route
//                 exact
//                 path="/SearchmoreCars"
//                 element={
//                   <SearchProvider>
//                     <SearchmoreCars />
//                   </SearchProvider>
//                 }
//               />

//               <Route
//                 exact
//                 path="/OtherCarDetails/:carno/"
//                 element={
//                   <SearchProvider>
//                     <OtherCarDetails />
//                   </SearchProvider>
//                 }
//               />

//               <Route exact path="/AllFrame" element={<AllFrame />} />
//               <Route
//                 exact
//                 path="/Specifiedcarcatlogue/"
//                 element={
//                   <SearchProvider>
//                     <Specifiedcarcatlogue />
//                   </SearchProvider>
//                 }
//               />
//               <Route
//                 exact
//                 path="/Specficatlogueshare/:id/:modelid/:Brand"
//                 element={<Specficatlogueshare />}
//               />
//               <Route
//                 exact
//                 path="/MessageTemplate"
//                 element={<MessageTemplate />}
//               />
//               <Route
//                 exact
//                 path="/ObjectDetection"
//                 element={<ObjectDetection />}
//               />
//               <Route exact path="/Challaninuse" element={<Challaninuse />} />
//               <Route exact path="/Report" element={<Report />} />
//               <Route
//                 exact
//                 path="/Stockrecord/:name"
//                 element={<Stockrecord />}
//               />
//               <Route
//                 exact
//                 path="/SearchBuyerSeller"
//                 element={<SearchBuyerSeller />}
//               />
//               <Route
//                 exact
//                 path="/AllUpdatedNotification"
//                 element={<AllUpdatedNotification />}
//               />
//               <Route
//                 exact
//                 path="/SalesExecutive"
//                 element={<SalesExecutive />}
//               />
//               <Route exact path="/Trashbin" element={<Trashbin />} />
//               <Route exact path="/Test" element={<Test />} />
//               <Route
//                 exact
//                 path="/MakeCustomizepost"
//                 element={<MakeCustomizepost />}
//               />
//               <Route
//                 exact
//                 path="/twashortcutmycatalogue"
//                 element={<TwaShortcutMyCatalogue />}
//               />
//               <Route
//                 exact
//                 path="/soldunsoldthismonth"
//                 element={<SoldUnsoldThisMonth />}
//               />
//               <Route
//                 exact
//                 path="/customercarlist"
//                 element={
//                   <CustomerCarProvider>
//                     <CustomerCarList />
//                   </CustomerCarProvider>
//                 }
//               />
//               <Route
//                 exact
//                 path="/customercardetail/:carRand"
//                 element={
//                   <CustomerCarProvider>
//                     <CustomerCarDetail />
//                   </CustomerCarProvider>
//                 }
//               />
//               <Route
//                 path="/gearwisecatalog"
//                 element={
//                   // <GearwiseCatalogProvider>
//                   <GearwiseCatalog />
//                   // </GearwiseCatalogProvider>
//                 }
//               />
//               <Route
//                 path="/gearwisecatalogshare/:dealerid/:gearid/:brandshowing"
//                 element={<GearwiseCatalogShare />}
//               />
//               <Route
//                 path="/fuelwisecatalog"
//                 element={
//                   // <FuelwiseContextProvider>
//                   <FuelwiseCatalog />
//                   // </FuelwiseContextProvider>
//                 }
//               />
//               <Route
//                 path="/fuelwisecatalogshare/:dealerid/:fuelid/:brandshowing"
//                 element={<FuelwiseCatalogShare />}
//               />
//             </Route>
//           </Routes>
//         </Router>
//       </NoInternetConnection>
//     </div>
//     // {/* </ApiProvider> */}
//   );
// }

// export default App;
